<template>
  <div>
    <HeaderCont />
    <TitleCont name1="youtube" name2="reference api" />
    <section class="cont__refer">
      <div class="container">
        <div class="youtube__inner">
          <div class="youtube__slider">
            <h2>Youtube ▶︎</h2>
            <swiper
              :slidesPerView="3"
              :spaceBetween="30"
              :freeMode="true"
              :pagination="{
                clickable: true,
              }"
              :modules="modules"
              class="mySwiper"
            >
              class="mySwiper" >
              <swiper-slide v-for="random in randoms" :key="random.id">
                <li>
                  <a
                    :href="`https://www.youtube.com/watch?v=${random.id.videoId}`"
                  >
                    <img
                      :src="`${random.snippet.thumbnails.medium.url}`"
                      :alt="`${random.snippet.description}`"
                    />
                  </a>
                </li>
              </swiper-slide>
            </swiper>
          </div>
          <!-- youtube__slider -->
          <div class="youtube__search">
            <div class="container">
              <form @submit.prevent="SearchYoutubes()">
                <input
                  type="search"
                  id="search"
                  placeholder="보고싶은 유튜브를 검색해주세요!"
                  v-model="search"
                />
                <button type="submit">검색</button>
              </form>
            </div>
          </div>
          <!-- //youtube__search -->
          <div class="youtube__images">
            <ul>
              <li v-for="youtube in youtubes" :key="youtube.id">
                <a href="`https://youtube.com/watch?v=${youtube.id.videoId}`">
                  <img
                    :src="`${youtube.snippet.thumbnails.medium.url}`"
                    :alt="youtube.snippet.description"
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- //youtube__images -->
    </section>
    <ContactCont />
    <FooterCont />
  </div>
</template>

<script>
import HeaderCont from "@/components/HeaderCont.vue";
import TitleCont from "@/components/TitleCont.vue";
import FooterCont from "@/components/FooterCont.vue";
import ContactCont from "@/components/ContactCont.vue";
import { ref } from "vue";

import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";

import "swiper/css/free-mode";
import "swiper/css/pagination";

// import "./style.css";
import { FreeMode, Pagination } from "swiper";
export default {
  components: {
    HeaderCont,
    FooterCont,
    TitleCont,
    ContactCont,
    Swiper,
    SwiperSlide,
  },
  setup() {
    const randoms = ref([]);
    const youtubes = ref([]);
    const sliders = ref([]);
    const search = ref("kpopplaylist");
    // async, await 데이터 다운이 늦을 수 있어서 비동기적으로 넣어주는 것임 리엑트에도!!
    const SearchYoutubes = async (e) => {
      await fetch(
        `https://youtube.googleapis.com/youtube/v3/search?part=snippet&q=${search.value}&key=AIzaSyAnrhZ_LMQJ-cTyTMyuGyxZI0grcJRQW20&maxResults=32&type=video`
      )
        .then((response) => response.json())
        .then((result) => {
          // console.log(result);
          youtubes.value = result.items;
          search.value = "";
          search.value = e;
        })
        .catch((error) => console.log(error));
    };
    SearchYoutubes();
    const RandomYoutubes = () => {
      fetch(
        "https://youtube.googleapis.com/youtube/v3/search?part=snippet&q=떼껄룩&key=AIzaSyAnrhZ_LMQJ-cTyTMyuGyxZI0grcJRQW20&maxResults=32&type=video"
      )
        .then((response) => response.json())
        .then((result) => (randoms.value = result.items))
        .catch((error) => console.log(error));
    };
    RandomYoutubes();
    return {
      youtubes,
      sliders,
      randoms,
      search,
      SearchYoutubes,
      modules: [FreeMode, Pagination],
    };
  },
};
</script>
<style lang="scss">
.youtube__inner {
  h2 {
    color: #fff;
    text-align: center;
    font-size: 30px;
    font-weight: 700;
    background-color: rgba(252, 0, 0, 0.823);
    border-radius: 10px;
    position: relative;
    padding: 5px 0;
    margin-bottom: 100px;
    font-family: var(--font-sub2);
  }
  .swiper-slide img {
    display: block;
    width: 100%;
    height: 300px;
    object-fit: cover;
  }

  em {
    display: block;
    height: 80px;
    margin-bottom: 60px;
    font-family: var(--font-kor2);
  }
  .title {
    padding: 5px 0;
    display: inline-block;
  }
  .star {
    background: #fff;
    color: #000;
    border-radius: 100px;
    position: absolute;
    right: 10px;
    top: 10px;
    width: 40px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    font-weight: 800;
  }
}

a {
  color: var(--black);
}

.youtube__search {
  margin-bottom: 100px;
  margin-top: 100px;

  .container {
    position: relative;
  }

  h2 {
    color: var(--black);
    font-size: 40px;
    text-indent: -9999px;
    height: 0;
  }
  input {
    background: #fff;
    border: 2px solid var(--white);
    border-radius: 50px;
    color: var(--black);
    width: 100%;
    padding: 14px 30px;
    font-family: var(--font-kor2);
  }
  button {
    position: absolute;
    right: 6px;
    top: 7px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 0;
    font-family: var(--font-kor2);
    cursor: pointer;
    z-index: 1000;
  }
}
.youtube__slider {
  .swiper {
    width: 100%;
    padding-top: 50px;
    padding-bottom: 40px;
  }

  .swiper-slide {
    background-position: center;
    background-size: cover;
    width: 300px;
    .title {
      padding: 5px 0;
      display: inline-block;
    }
  }

  .swiper-slide img {
    display: block;
    width: 100%;
    height: 400px;
  }
}
.Youtubelist {
  position: relative;
  transition: all 0.4s;
  &:hover {
    transform: scale(1.02);
  }
}
.youtube__images {
  ul {
    column-count: 4;
    column-gap: 20px;
    width: 100%;

    li {
      margin-bottom: 20px;

      img {
        border-radius: 5px;
      }
    }
  }
}
</style>
